const config = {
  api: process.env.REACT_APP_API || "http://localhost:5000/forex",
  api_move: process.env.REACT_APP_API_MOVE,
};

export default config;